export default {
  nav: {
    technology: "ODFテクノロジー",
    solutions: "ソリューション",
    partnerships: "パートナーシップ",
    about: "会社情報",
    contact: "お問い合わせ",
    home: "ホーム",
  },
  hero: {
    eyebrow: "次世代のODFソリューション",
    headline1: "イノベーションを、",
    headline2: "一枚のフィルムに。",
    copy: "NORTISは、先進的な口腔内溶解フィルム（Orally Dissolving Film：ODF）製品を、現代のウェルネスブランドと国際市場へお届けします。利便性の高いフォーマットと、信頼できる商業的専門知識を融合します。",
    cta1: "ODFテクノロジーを見る",
    cta2: "NORTISとのパートナーシップ",
    trust: "現代のライフスタイルのために設計。グローバルな機会のために構築。",
    scroll: "スクロール",
  },
  brandline: "先進のデリバリー。手間のない体験。",
  credibility: {
    title: "変化する世界のための、よりスマートなフォーマット。",
    copy: "口腔内溶解フィルムは、丁寧に設計された成分を、錠剤・カプセル・液体といった従来の形態によらず、洗練された便利な方法で届けることを可能にします。",
  },
  whatIsOdf: {
    eyebrow: "フォーマットについて",
    title: "ODFとは",
    copy: "ODFは、口の中で快適に溶けるよう設計された極薄の経口フィルムです。そのコンパクトなフォーマットは、携帯性に優れ、使いやすいウェルネス体験を開発するブランドに、現代的な選択肢を提供します。",
    benefits: [
      { title: "薄くて携帯しやすい", desc: "ポケットにも財布にもバッグにも、どこへでも気軽に持ち運べる極薄フォーマット。" },
      { title: "水なしで使える", desc: "水も準備も不要。いつでもどこでも使えるように設計されています。" },
      { title: "正確な個包装", desc: "各フィルムは一枚ずつ個別に包装され、品質の一貫性が保たれています。" },
      { title: "イノベーションのために", desc: "現代的な製品コンセプトと差別化されたブランド体験を実現する、柔軟な基盤です。" },
    ],
  },
  whyNortis: {
    eyebrow: "NORTISが選ばれる理由",
    title: "製品フォーマットを超えた、確かな市場機会。",
    copy: "NORTISは、ODFイノベーションと商業市場をつなぐ架け橋です。有望な製品と、それを拡大できるパートナーを結び付けます。",
    points: [
      { title: "ODFに特化した商業的専門知識", desc: "口腔内溶解フィルムというカテゴリーと、その商業的ダイナミクスに専念しています。" },
      { title: "国際的な調達と市場開発", desc: "各地域における機会の発掘と、市場への流通経路の構築を行います。" },
      { title: "製品・ブランドポジショニング支援", desc: "パートナーがODFコンセプトを自社の顧客層と販売チャネルに適合させられるよう支援します。" },
      { title: "柔軟なB2Bパートナーシップモデル", desc: "ディストリビューション、プライベートブランド、市場開発——貴社の目標に合わせて構成します。" },
      { title: "品質を重視した製品選定", desc: "適合性・文書・市場対応力を規律ある姿勢で評価します。" },
      { title: "長期的な関係構築", desc: "持続的かつ累積的な事業成長のために築かれるパートナーシップです。" },
    ],
  },
  solutions: {
    eyebrow: "ソリューションポートフォリオ",
    title: "現代のライフスタイルを中心に設計されたポートフォリオ。",
    copy: "NORTISが世界中のパートナーおよび市場とともに開発するソリューションカテゴリーをご覧ください。",
    viewAll: "すべてのソリューションを見る",
    requestInfo: "製品情報を請求する",
    possibilitiesLabel: "開発の可能性",
    positioningLabel: "商業的ポジショニング",
    availabilityLabel: "市場での提供状況",
    targetLabel: "ターゲット市場",
    docLabel: "文書の整備状況",
    sheetLabel: "製品情報シート",
    sheetOnRequest: "ご要望に応じて提供",
    demoBadge: "デモンストレーション用コンセプト",
    filterAll: "すべて",
    pageTitle: "ソリューション",
    pageSub: "ODFソリューションカテゴリーの絞り込み可能なポートフォリオです。パートナーシップの進展に応じて、実際の製品を追加できる構成になっています。",
    demoNote: "以下の項目は、各カテゴリーの方向性を示すデモンストレーション用コンセプトです。実際の商業製品は、進行中のパートナーシップの中でご紹介します。",
  },
  comparison: {
    eyebrow: "フォーマット比較",
    title: "フィルムフォーマットの比較。",
    copy: "日常的なフォーマットの実用的な特性を、中立的な視点で比較します。",
    note: "本表はフォーマットの実用的な特性のみを中立的に比較したものであり、臨床的な性能や有効性を示すものではありません。",
    formats: ["ODFフィルム", "錠剤", "カプセル", "液体"],
    rows: [
      { label: "携帯性", values: [2, 2, 2, 0] },
      { label: "水なしでの使用", values: [2, 0, 0, 1] },
      { label: "1回分ずつの個包装", values: [2, 2, 2, 0] },
      { label: "保管のしやすさ", values: [2, 2, 1, 0] },
      { label: "外出先での目立たない使用", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "パートナーシップモデル",
    title: "NORTISとともに成長する3つの方法。",
    cta: "パートナーシップのご相談",
    items: [
      { title: "ディストリビューション", desc: "厳選されたODF製品を、新たな地域と販売ネットワークへ展開します。" },
      { title: "プライベートブランド", desc: "貴社ブランドのもとで、差別化されたODFコンセプトを開発します。" },
      { title: "市場開発", desc: "NORTISとともに、製品ポジショニング、ローンチ戦略、長期的な市場プレゼンスを構築します。" },
    ],
  },
  timeline: {
    eyebrow: "協業の進め方",
    title: "最初の対話から、市場での成長まで。",
    steps: [
      { title: "機会の発見", desc: "貴社の目標と市場、そしてそれに適したODFコンセプトを共に検討します。" },
      { title: "製品と市場の適合", desc: "適切な製品を、適切な商業的環境と結び付けます。" },
      { title: "商業的評価", desc: "条件、数量、現実的な商業的枠組みを設計します。" },
      { title: "コンプライアンスとローンチ準備", desc: "発売前に文書と市場要件を確認します。" },
      { title: "流通と成長", desc: "展開・拡大、そしてパートナーシップの長期的な成長を支援します。" },
    ],
  },
  quality: {
    eyebrow: "品質と責任",
    title: "品質は、正しい問いから始まる。",
    copy: "NORTISは、すべてのパートナーシップ候補において、製品の適合性、文書、商業的な準備状況、市場要件を評価します。製品の入手可能性および規制上の位置付けは、国によって異なる場合があります。",
    placeholder: "検証済みの品質文書および認証は、パートナーシップの進展に応じてこちらに掲載します。",
  },
  global: {
    eyebrow: "グローバルな視野",
    title: "国際的な協業のために",
    copy: "変化し続けるグローバル市場において意義あるODFの機会を見出すため、ブランド、サプライヤー、ディストリビューター、そして商業パートナーとともに取り組んでいます。",
  },
  finalCta: {
    title: "オーラルウェルネスの次世代を、ともに形づくりましょう。",
    copy: "ディストリビューション、プライベートブランド、新しいODF製品コンセプト——どのご検討であっても、NORTISはいつでも対話を始める準備ができています。",
    cta: "お問い合わせはこちら",
  },
  footer: {
    desc: "NORTISは、革新的なODF製品を世界中のブランド、パートナー、市場とつなぎます。",
    nav: "サイトマップ",
    legal: "法的情報",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    language: "言語",
    disclaimer: "製品の入手可能性、処方、分類および規制上の位置付けは、国によって異なる場合があります。本ウェブサイトの情報は、商業的および一般的な情報提供を目的としたものであり、医学的助言を構成するものではありません。",
    rights: "無断複写・転載を禁じます。",
  },
  tech: {
    eyebrow: "ODFテクノロジー",
    title: "「薄さ」の科学。",
    sub: "口腔内溶解フィルムについての教育的な概要——フォーマット、使用体験、そしてそれが開く商業的可能性。",
    what: {
      title: "口腔内溶解フィルムとは",
      copy: "口腔内溶解フィルム（ODF）は、口の中で快適に溶けるよう設計された極薄のシートです。錠剤を飲み込んだり液体を計量したりする代わりに、フィルムを一枚口に含み、溶けるのを待つだけ。驚くほどコンパクトなフォーマットで、静かで現代的な体験を提供します。",
    },
    structure: {
      title: "フィルムの基本構造",
      copy: "概念的には、ODFは構造を支えるフィルムベース、配合成分を保持するキャリアマトリックス、そして味と食感を左右する感覚レイヤーで構成されます。図にカーソルを合わせるかタップすると、概念上のレイヤーが分離します。",
      note: "説明のための概念図です。",
      layers: [
        { title: "感覚レイヤー", desc: "味、食感、溶解時の体験を形づくります。" },
        { title: "キャリアマトリックス", desc: "丁寧に配合された成分をフィルム内に保持します。" },
        { title: "構造ベース", desc: "フィルムに一体性、薄さ、安定性をもたらします。" },
      ],
    },
    experience: {
      title: "使用体験",
      copy: "水も、計量も、中断も不要。フィルムは目立つことなく溶けるため、旅行中も仕事中も移動中も、自然に使うことができます。現代の消費者にとって、フォーマットそのものがブランド体験の一部になります。",
    },
    portability: {
      title: "携帯性とパッケージの可能性",
      copy: "個包装のフィルムは、スリムなサシェ、上質なマルチパック、コンパクトなディスペンサーなどで展開できます。現代の小売店の棚にも、D2Cの開封体験にもふさわしいフォーマットです。",
    },
    development: {
      title: "製品開発の可能性",
      copy: "フィルムフォーマットは、日々のウェルネス習慣からターゲットを絞ったライフスタイル提案まで、幅広い製品コンセプトに対応し、競争の激しいカテゴリーにおいてブランドに差別化の余地をもたらします。",
    },
    commercial: {
      title: "商業的な応用分野",
      copy: "ODFコンセプトは、ウェルネス、インナービューティー、エナジー、睡眠、機能性成分などのカテゴリーで開発が進んでいます。いずれも、利便性とプレミアムな体験が購買決定を左右するチャネルです。",
    },
    regulatory: {
      title: "市場および規制上の考慮事項",
      copy: "フィルム製品の分類と要件は、国や処方によって異なります。NORTISは各市場に個別に向き合い、商業化の前にパートナーとともに文書と規制環境を確認します。",
    },
    cta: "技術情報を請求する",
  },
  partnership: {
    eyebrow: "プライベートブランドとディストリビューション",
    title: "2つの道。1つのパートナーシップ基準。",
    sub: "NORTISは、商業的な協業を2つの主要モデルを軸に構成しています。いずれも、明確さ、スピード、長期的な成長を重視して設計されています。",
    plTitle: "プライベートブランド",
    plDesc: "コンセプトから店頭までの道のりをNORTISがコーディネートし、貴社ブランドのもとで差別化されたODFコンセプトを開発します。",
    plSteps: ["コンセプト評価", "製品選定", "ブランディングとパッケージの調整", "文書の確認", "市場投入の準備", "商業的スケールアップ"],
    distTitle: "ディストリビューション",
    distDesc: "各段階で体系的なサポートを受けながら、厳選されたODF製品を貴社のテリトリーと販売ネットワークへ展開します。",
    distSteps: ["テリトリー評価", "ポートフォリオの適合", "商業条件", "市場参入計画", "ローンチ支援", "長期的な成長"],
    formTitle: "パートナーシップに関するお問い合わせ",
    formSub: "貴社の目標をお聞かせください。担当チームが次のステップをご案内します。",
  },
  about: {
    eyebrow: "NORTISについて",
    title: "明日を形づくるフォーマットに、焦点を。",
    copy: "NORTISは、有望なODFイノベーションを、それを意義ある商業製品へと転換できるブランド、パートナー、市場と結び付けるために設立されました。起業家的なスピード、国際的な視点、そして長期的なパートナーシップへの規律ある姿勢を融合しています。",
    positioning: "NORTISは、革新的なODF製品を世界中のブランド、パートナー、市場とつなぎます。",
    principlesTitle: "私たちの原則",
    principles: [
      { title: "精緻さ", desc: "製品評価からパートナーとのコミュニケーションまで、あらゆる細部への配慮。" },
      { title: "信頼", desc: "透明性のある期待値と、守り抜くための約束。" },
      { title: "前進", desc: "進化と現代的なフォーマットへの確かな志向。" },
      { title: "パートナーシップ", desc: "四半期ではなく、年月をかけて価値を育む関係。" },
      { title: "グローバルな視点", desc: "国境、市場、消費文化を越えて考えること。" },
    ],
  },
  contact: {
    eyebrow: "お問い合わせ",
    title: "まずは、お話をお聞かせください。",
    sub: "ご関心の内容について簡単にご記入いただければ、担当チームよりご連絡いたします。",
    name: "氏名",
    company: "会社名",
    email: "ビジネスメールアドレス",
    country: "国",
    website: "ウェブサイト",
    interest: "ご関心のあるパートナーシップ",
    market: "想定されている市場・地域",
    message: "メッセージ",
    consent: "本お問い合わせへの対応を目的として、NORTISが私の情報を保管することに同意します。",
    submit: "送信する",
    sending: "送信中…",
    successTitle: "ありがとうございます。メッセージを受け付けました。",
    successCopy: "担当チームがお問い合わせ内容を確認のうえ、追ってご連絡いたします。",
    successAnother: "別のメッセージを送る",
    errorRequired: "この項目は必須です。",
    errorEmail: "有効なビジネスメールアドレスを入力してください。",
    errorConsent: "フォームの送信には同意が必要です。",
    errorSubmit: "エラーが発生しました。もう一度お試しください。",
    optional: "任意",
    interests: {
      distribution: "ディストリビューション",
      privateLabel: "プライベートブランド",
      sourcing: "製品調達",
      marketDev: "市場開発",
      general: "パートナーシップ全般",
      product: "製品情報",
      technical: "技術情報",
    },
    selectPlaceholder: "選択してください",
  },
  legal: {
    privacyTitle: "プライバシーポリシー",
    termsTitle: "利用規約",
    updated: "最終更新日",
    privacy: [
      { h: "1. 概要", p: "本プライバシーポリシーは、NORTISが本ウェブサイトを通じて提供された情報をどのように収集、利用、保護するかを説明するものです。当社は、ビジネス上の連絡先情報を責任を持って透明性のある方法で取り扱うことをお約束します。" },
      { h: "2. 収集する情報", p: "お問い合わせフォームまたはパートナーシップフォームを送信いただいた際、氏名、会社名、ビジネスメールアドレス、国、ウェブサイト、ご関心の分野、メッセージ内容など、ご提供いただいた情報を収集します。" },
      { h: "3. 情報の利用方法", p: "ご提供いただいた情報は、お問い合わせへの回答、商業的な協業の可能性の評価、および関連するパートナーシップ事項についての連絡のためにのみ利用します。個人情報を販売することはありません。" },
      { h: "4. データの保管とセキュリティ", p: "フォームの送信内容は、当社アプリケーションのデータベースに安全に保管されます。アクセスは、お問い合わせ対応に必要な担当者に限定されます。保管データの保護のため、合理的な技術的措置を講じています。" },
      { h: "5. データの保持期間", p: "お問い合わせデータは、ビジネス関係の管理に必要な期間、または適用法令が求める期間、保持します。データの削除は、当社までご連絡いただくことで請求できます。" },
      { h: "6. お客様の権利", p: "お住まいの法域によっては、当社が保有するお客様の個人データへのアクセス、訂正、削除を求める権利を有する場合があります。これらの権利を行使される場合は、本ウェブサイトからご連絡ください。" },
      { h: "7. 本ポリシーの変更", p: "本プライバシーポリシーは随時更新されることがあります。重要な変更は、更新日とともに本ページに反映されます。" },
    ],
    terms: [
      { h: "1. 規約の同意", p: "本ウェブサイトにアクセスし利用することにより、お客様は本利用規約に同意したものとみなされます。同意いただけない場合は、本サイトのご利用をお控えください。" },
      { h: "2. 情報提供の目的", p: "本ウェブサイトのコンテンツは、商業的および一般的な情報提供のみを目的としています。医学的、法的、または規制上の助言を構成するものではなく、いかなるコンテンツも製品に関する効能の主張として解釈されるべきではありません。" },
      { h: "3. 製品の入手可能性", p: "製品の入手可能性、処方、分類および規制上の位置付けは、国によって異なる場合があります。本ウェブサイト上のいかなる内容も、特定の法域における製品の販売の申し出を構成するものではありません。" },
      { h: "4. 知的財産", p: "NORTISの名称、ビジュアルアイデンティティおよびウェブサイトのコンテンツは、NORTISに帰属します。事前の書面による許可なく、サイトのコンテンツを複製または配布することはできません。" },
      { h: "5. 責任の制限", p: "NORTISは、ウェブサイトの情報を正確に保つよう合理的な努力を行いますが、その完全性を保証するものではありません。法令の許す範囲において、NORTISはウェブサイトのコンテンツに基づいて行われた判断について責任を負いません。" },
      { h: "6. 第三者リンク", p: "本ウェブサイトには、第三者のリソースへのリンクが含まれる場合があります。NORTISは、外部サイトのコンテンツや運営について責任を負いません。" },
      { h: "7. 規約の適用", p: "本規約は定期的に更新されることがあります。本ウェブサイトの継続的な利用は、最新版への同意を意味します。" },
    ],
  },
  seo: {
    home: { title: "NORTIS — 先進のODFソリューション | 口腔内溶解フィルムのパートナー", desc: "NORTISは、革新的な口腔内溶解フィルム（ODF）製品を世界中のブランド、パートナー、市場とつなぎます。ディストリビューション、プライベートブランド、市場開発。" },
    tech: { title: "ODFテクノロジー — NORTIS", desc: "口腔内溶解フィルム技術の教育的な概要：フォーマット、構造、使用体験、商業的可能性。" },
    solutions: { title: "ODFソリューションポートフォリオ — NORTIS", desc: "ODFソリューションカテゴリーをご覧ください：デイリーウェルネス、エナジー、ビューティー、睡眠、機能性成分、プライベートブランドコンセプト。" },
    partnership: { title: "プライベートブランドとディストリビューション — NORTIS", desc: "ODF製品のディストリビューション、プライベートブランド、市場開発モデルを通じて、NORTISとのパートナーシップを。" },
    about: { title: "NORTISについて — 明日を形づくるフォーマットに焦点を", desc: "NORTISは、有望なODFイノベーションを商業製品へ転換できるブランド、パートナー、市場と結び付けます。" },
    contact: { title: "NORTISへのお問い合わせ — 対話を始める", desc: "ODFのディストリビューション、プライベートブランド、調達、市場開発について、NORTISチームまでご連絡ください。" },
    privacy: { title: "プライバシーポリシー — NORTIS", desc: "NORTISが本ウェブサイトを通じて提供された情報をどのように収集、利用、保護するかについて。" },
    terms: { title: "利用規約 — NORTIS", desc: "NORTISウェブサイトおよびその情報コンテンツの利用に関する規約。" },
  },
  a11y: {
    mainNav: "メインナビゲーション",
    mobileNav: "モバイルナビゲーション",
    homeLink: "NORTISホーム",
    openMenu: "メニューを開く",
    closeMenu: "メニューを閉じる",
    langSelector: "言語を選択",
    filmDiagram: "インタラクティブなフィルムレイヤー図",
    linkedinLabel: "LinkedInのNORTIS",
    techImageAlt: "重なり合う抽象的なフィルムシート",
    yes: "はい",
    partial: "一部対応",
    no: "いいえ",
    filters: "ソリューションフィルター",
  },
  solutionsData: {
    "daily-wellness": {
      name: "デイリーウェルネス",
      desc: "現代の朝と夜の習慣に自然に溶け込むよう設計された、毎日のためのフィルムコンセプト。",
      possibilities: ["習慣に根ざした製品ライン", "サブスクリプションに適したフォーマット", "ミニマルなプレミアムパッケージ"],
      positioning: "手間なく毎日続けたい消費者に向けたポジショニング。",
      availability: "パートナーと開発中",
      targetMarket: "ウェルネス・ライフスタイル小売",
      docStatus: "市場ごとに準備",
    },
    "energy-performance": {
      name: "エナジー＆パフォーマンス",
      desc: "トレーニング前、移動前、多忙な一日の前に。勢いを大切にする消費者のための持ち運びやすいコンセプト。",
      possibilities: ["アクティビティ前のポジショニング", "コンパクトなマルチパックフォーマット", "大胆で現代的なブランド表現"],
      positioning: "スピードと利便性を重視する消費シーンのために。",
      availability: "パートナーと開発中",
      targetMarket: "アクティブライフスタイル・スポーツチャネル",
      docStatus: "市場ごとに準備",
    },
    "beauty-aging": {
      name: "ビューティー＆ヘルシーエイジング",
      desc: "体験と美しさが重視されるインナービューティーカテゴリーのための、エレガントなフィルムコンセプト。",
      possibilities: ["プレミアムビューティーのポジショニング", "ギフト向けパッケージコンセプト", "リチュアルを軸にしたブランドストーリー"],
      positioning: "毎日の美容習慣を高めるブランドのための、洗練されたフォーマット。",
      availability: "パートナーと開発中",
      targetMarket: "インナービューティー・プレミアム小売",
      docStatus: "市場ごとに準備",
    },
    "sleep-relaxation": {
      name: "睡眠＆リラクゼーション",
      desc: "一日の終わりのシンプルさを軸に設計された、穏やかで夜向けのコンセプト。",
      possibilities: ["夜のリチュアルとしてのポジショニング", "ベッドサイドに適した控えめなフォーマット", "心を落ち着かせる感覚的デザイン"],
      positioning: "休息の前の静かなひとときのために。",
      availability: "パートナーと開発中",
      targetMarket: "ナイトウェルネス・薬局小売",
      docStatus: "市場ごとに準備",
    },
    "vitamins-functional": {
      name: "ビタミン＆機能性成分",
      desc: "定評ある機能性成分を軸に、精緻で現代的なフォーマットで提案するフィルムコンセプト。",
      possibilities: ["成分を軸にした製品ファミリー", "明快で誠実なラベルデザイン", "フォーマットによる差別化"],
      positioning: "確立された成分カテゴリーにおける、現代的な選択肢。",
      availability: "パートナーと開発中",
      targetMarket: "ニュートラシューティカル・機能性小売",
      docStatus: "市場ごとに準備",
    },
    "custom-private-label": {
      name: "カスタム＆プライベートブランドコンセプト",
      desc: "白いキャンバス：アイデアからローンチまで、パートナーのブランドのもとで開発されるオーダーメイドのODFコンセプト。",
      possibilities: ["完全オーダーメイドのコンセプト開発", "ブランドとパッケージの調整", "ローンチとスケールアップの支援"],
      positioning: "まぎれもなく自社のものと言える、差別化された製品を求めるパートナーのために。",
      availability: "ご相談を受付中",
      targetMarket: "ブランドオーナー・小売事業者",
      docStatus: "プロジェクトごとに定義",
    },
  },
};
